<template>
  <div class="w-full h-full">
<woot-modal :show.sync="show" :on-close="onClose">
  <woot-modal-header
    :header-title="'Have you taken the follow up?'"
  />
  
  <div class="flex justify-end gap-4 p-6">
    <woot-button variant="smooth" color-scheme="primary" @click="handleFollowUp('yes')">
      Yes
    </woot-button>
    <woot-button variant="clear" color-scheme="secondary" @click="handleFollowUp('no')">
      No
    </woot-button>
  </div>
</woot-modal>
</div>
</template>


<script>
import alertMixin from 'shared/mixins/alertMixin';
export default {
  props: {
    primaryContact: {
      type: Object,
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [alertMixin],
methods: {
    onClose() {
      this.$emit('close');
    },
    async handleFollowUp(response) {
      if (response !== 'yes') {
        this.onClose();
        return;
      }

      try {
        const responses = await this.$store.dispatch('contacts/demo_mark_read', {
          contactId: this.primaryContact.id,
          data: { isReaded: true },
        });

        if (responses?.success) {
          this.showAlert('Reminder mark as done', { success: true });
          if (this.primaryContact.additional_attributes) {
            this.primaryContact.additional_attributes.calendar_timings = null;
            this.primaryContact.additional_attributes.reminder_note = null;
          }
          bus.$emit('set-reminder-updated', true);
          this.$emit('success-message');
          this.onClose();
          return;
        }

        this.showAlert('Unable to mark reminder as done', { success: false });
      } catch (error) {
        console.error('Error marking reminder as done:', error);
        this.showAlert('Unable to mark reminder as done', { success: false });
      }
    },
}
}
  </script>